import { createSelector } from 'reselect';
import { KEY } from './';
import { GlobalState } from 'store/types';

const getConfigurationsState = (state: GlobalState) => state[KEY];

const selectConfigurations = createSelector(getConfigurationsState, (state) => state.configurations);

const selectAction = createSelector(getConfigurationsState, (state) => state.action);

const selectPending = createSelector(getConfigurationsState, (state) => state.action.pending);

const selectError = createSelector(getConfigurationsState, (state) => state.action.error);

export const selectors = {
  selectConfigurations,
  selectAction,
  selectPending,
  selectError
};
